import { gsap } from 'gsap';

function initHeroAnimations() {
	const heroBlocks = document.querySelectorAll('.tylovyky-hero');

	heroBlocks.forEach((block) => {
		const stripesContainer = block.querySelector('.hero-stripes');
		if (!stripesContainer) return;

		const tracks = stripesContainer.querySelectorAll('.stripe-track');
		let animations = [];

		// Calculate speed based on screen width
		const getSpeed = () => {
			const width = window.innerWidth;
			if (width < 640) return 15; // Mobile
			if (width < 1024) return 20; // Tablet
			if (width < 1920) return 25; // Desktop
			if (width < 2560) return 35; // Large desktop
			return 50; // Ultra-wide/4K
		};

		const startAnimations = () => {
			// Kill existing animations
			animations.forEach(anim => anim.kill());
			animations = [];

			const SPEED = getSpeed();

			tracks.forEach((track, idx) => {
				// scrollWidth contains 4 sets of images
				// Quarter = one complete set
				const quarterWidth = track.scrollWidth / 4;
				if (quarterWidth === 0) return;

				const duration = quarterWidth / SPEED;
				const direction = idx % 2 === 0 ? -1 : 1; // Even rows go left, odd go right

				// Natural seamless loop: animate from 0 to -quarterWidth (or reverse)
				// GSAP's repeat: -1 handles the loop seamlessly without manual resets
				const anim = gsap.fromTo(
					track,
					{ x: direction === -1 ? 0 : -quarterWidth },
					{
						x: direction === -1 ? -quarterWidth : 0,
						duration,
						ease: 'none',
						repeat: -1,
					}
				);

				animations.push(anim);
			});
		};

		// Wait for all images to load before starting animations
		const allImages = stripesContainer.querySelectorAll('.stripe-image img');
		let loadedCount = 0;
		const totalImages = allImages.length;

		const checkAllLoaded = () => {
			loadedCount++;
			if (loadedCount >= totalImages) {
				// Use double rAF to ensure layout is fully calculated
				requestAnimationFrame(() => {
					requestAnimationFrame(startAnimations);
				});
			}
		};

		// Check each image's load state
		allImages.forEach((img) => {
			if (img.complete && img.naturalHeight > 0) {
				checkAllLoaded();
			} else {
				img.addEventListener('load', checkAllLoaded, { once: true });
				img.addEventListener('error', checkAllLoaded, { once: true });
			}
		});

		// Handle edge case: no images
		if (totalImages === 0) {
			startAnimations();
		}

		// Handle window resize with debounce
		let resizeTimeout;
		const handleResize = () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				startAnimations();
			}, 150);
		};

		window.addEventListener('resize', handleResize);

		// Store animations and cleanup function
		block._heroAnimations = animations;
		block._heroCleanup = () => {
			animations.forEach(anim => anim.kill());
			window.removeEventListener('resize', handleResize);
		};
	});
}

// Initialize on page load
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initHeroAnimations);
} else {
	initHeroAnimations();
}
